/**
 * Format a phone number for display with dashes.
 * Handles common US formats: "5551234567" → "555-123-4567"
 * Passes through already-formatted or international numbers.
 */
export function formatPhone(phone) {
  if (!phone) return '';
  // Strip everything except digits
  const digits = phone.replace(/\D/g, '');
  // 10 digits: XXX-XXX-XXXX
  if (digits.length === 10) {
    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  // 11 digits starting with 1: 1-XXX-XXX-XXXX
  if (digits.length === 11 && digits[0] === '1') {
    return `1-${digits.slice(1, 4)}-${digits.slice(4, 7)}-${digits.slice(7)}`;
  }
  // Already formatted or international — return as-is
  return phone;
}
